<h3>Users</h3>

<table class="table table-striped">
	<thead>
		<tr>
			<th scope="col" class="text-center">Admin</th>
			<th scope="col">ID</th>
			<th scope="col">Name</th>
			<th scope="col">Email</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let user of users">
			<td class="text-center">
				<input class="form-check-input" type="checkbox" disabled [ngModel]="isAdmin(user)" />
			</td>
			<td><a [routerLink]="user.id" title="Edit User">{{user.id}}</a></td>
			<td>{{user.name}}</td>
			<td>{{user.email}}</td>
		</tr>
	</tbody>
</table>